import { PERSONAL_PAGE_SUBTYPE_LABELS } from '../../labels';
import { cap } from '../capability-builder';
import { emptyLabels, serviceLabels, serviceOptions } from '../item-presets';
import { DEFAULT_DEFINE_STEP_ACCORDION_ORDER, type PersonalPageCapabilities } from '../types';

export const informationCapabilities: Record<string, PersonalPageCapabilities> = {
  serviceRegistration: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.serviceRegistration.singular,
    itemKind: 'service',
    itemOptions: serviceOptions,
    dataDestination: 'registrations',
    itemLabels: serviceLabels,
    defineStepAccordionOrder: DEFAULT_DEFINE_STEP_ACCORDION_ORDER.map(id =>
      id === 'pageLimits' ? 'advancedTickets' : id
    ),
    defineStepLabelConfig: {
      formSubject: 'הרשמה',
      overrides: {
        registrationLimitTitle: 'מכסה כוללת לדף',
        registrationLimitSubtitle: 'הגבלת סך ההרשמות בדף (בנוסף למלאי לכל סוג שירות)',
        ticketSection: {
          title: 'סוגי שירותים',
          description: 'הוסף ונסה סוגי שירותים שונים',
          buttonText: 'הוסף סוג שירות חדש',
          emptyText: 'אין סוגי שירותים מוגדרים עדיין. לחץ על "הוסף סוג שירות חדש" כדי להתחיל.',
          addTitle: 'הוספת סוג שירות חדש',
          editTitle: 'עריכת סוג שירות',
          deleteTitle: 'מחיקת סוג שירות',
          deleteConfirmTitle: 'סוג שירות',
          priceRowLabel: 'מחיר',
          inventoryRowLabel: 'מלאי',
          amountFieldLabel: 'מחיר'
        }
      }
    }
  }),

  leads: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.leads.singular,
    allowDonationAtEnd: true,
    dataDestination: 'registrationsAndLeads',
    itemLabels: emptyLabels,
    defineStepLabelConfig: {
      formSubject: 'פנייה'
    }
  }),

  fixedFormLead: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.fixedFormLead.singular,
    dataDestination: 'none',
    defineStepLabelConfig: { formSubject: 'פנייה' }
  })
};
